/**
 * Routes API requests to either the Vercel edge functions (web)
 * or the local sidecar (desktop).
 */

import { isTauriRuntime } from '@/utils/tauri';

let sidecarBase: string | null = null;

/** Set the sidecar base URL (called once on desktop boot). */
export function setSidecarUrl(url: string): void {
  sidecarBase = url;
}

/** Get the base URL for API requests. */
export function getApiBase(): string {
  if (isTauriRuntime() && sidecarBase) {
    return sidecarBase;
  }
  return ''; // Relative URL = same origin (Vercel)
}

/** Check if running in desktop mode. */
export function isDesktop(): boolean {
  return isTauriRuntime();
}
